export const migrations = {
  0: (state) => {
    return {}
  },
  1: (state) => {
    return {}
  },
  2: (state) => {
    return {}
  },
  3: (state) => {
    return {}
  },
  4: (state) => {
    return {}
  },
  5: (state) => {
    return {}
  },
  6: (state) => {
    return {}
  },
  7: (state) => {
    return {}
  },
  8: (state) => {
    return {}
  },
  9: (state) => {
    return {}
  },
  10: (state) => {
    return {}
  },
  11: (state) => {
    return {}
  },
  12: (state) => {
    return {}
  },
  13: (state) => {
    return {}
  },
  14: (state) => {
    return {}
  },
  15: (state) => {
    return {}
  },
  16: (state) => {
    return {}
  },
  17: (state) => {
    return {}
  },
  18: (state) => {
    return {}
  },
  19: (state) => {
    return {}
  },
  20: (state) => {
    return {}
  },
};
